/**
 * `email_templates.id` values used by Underwriting Config (legacy Angular: Missing = 72, Denied = 16).
 */
export const UW_EMAIL_CHECKBOX_TEMPLATE_ID = {
  MISSING_INFO: 72,
  DENIED_REASON: 16,
} as const
